import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ServicesSection.css";

const ServicesSection = () => {
  const services = [
    {
      title: "Tempo Traveller On Rent in Pune",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Pune with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/1.jpg",
      link: "/booking",
    },
    {
      title: " Pune to Goa Tempo Traveller Hire",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Delhi with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/4.jpg",
      link: "/booking",
    },
    {
      title: " Mini Bus On Rent in Pune",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Bangalore with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/9.jpg",
      link: "/booking",
    },
    {
      title: "35 Seater Bus on Rent in Pune",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Chennai with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/15.jpg",
      link: "/booking",
    },
    {
      title: "45 Seater Bus On Rent in Pune",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Jaipur with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/16.jpg",
      link: "/booking",
    },
    {
      title: "AC Bus On Rent in Pune",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Hyderabad with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/22.jpg",
      link: "/booking",
    },

       {
      title: "Pune to Outstation Bus",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Chennai with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/pune-to-outstation-bus.jpeg",
      link: "/booking",
    },
    {
      title: " Pune to Shirdi Bus",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Jaipur with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/Pune-to-shirdi-bus.jpeg",
      link: "/booking",
    },
    {
      title: "Pune to Mahabaleshwar Bus",
      description:
        "Pune Corporate Cars India Private Limited offers reliable and affordable corporate cab services in Hyderabad with experienced drivers and well-maintained vehicles. Whether you are traveling for business meetings, office commutes, or client visits, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/Pune-to-mahableshwar-bus.jpeg",
      link: "/booking",
    },
  ];

  return (

<>

  <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  Services
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





    <section className="services-section py-5">
      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="service-card shadow-sm h-100">
                <img src={service.image} alt={service.title} className="img-fluid" />
                <div className="p-3">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-desc">{service.description}</p>
                  <a href={service.link} className="book-btn btn btn-warning w-100">
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

</>
  );
};

export default ServicesSection;
